import mutationGQL from "@/Apollo/mutation/setPreferredCurrency.graphql";
import {
  SetPreferredCurrencyMutation,
  SetPreferredCurrencyMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions, useMutation } from "@apollo/client";

/** Saves the buyer's display currency on their account (WHO-5143); answers the updated `Member`. */
export const useSetPreferredCurrency = (
  options?: MutationHookOptions<
    SetPreferredCurrencyMutation,
    SetPreferredCurrencyMutationVariables
  >
) => useMutation(mutationGQL, options);
